<template>
    <div class="benefit">
        <div class="landing-container wrap">
            <img class="dressing-ball" src="@/assets/img/landingPage/home/ball.svg" alt="">
            <div class="title">
                <img src="@/assets/img/landingPage/home/fire.svg" alt="">
                房東與物管公司的最佳選擇
            </div>
            <ul>
                <li>
                    <img src="@/assets/img/landingPage/home/typeA/landlord.svg" alt="">
                    <div class="count">
                        <countTo ref="counter1" class="count" :startVal='0' :endVal='1000' :duration='3000' :autoplay="false" suffix="+" separator="" :useEasing="true">+</countTo>
                    </div>
                    <div class="name">
                        房東數量
                    </div>
                </li>
                <li>
                    <img src="@/assets/img/landingPage/home/typeA/briefcase.svg" alt="">
                    <div class="count">
                        <countTo ref="counter2" class="count" :startVal='0' :endVal='1000' :duration='3000' :autoplay="false"  suffix="+" separator="" :useEasing="true">+</countTo>
                    </div>
                    <div class="name">
                        房客數量
                    </div>
                </li>
                <li>
                    <img src="@/assets/img/landingPage/home/typeA/house.svg" alt="">
                    <div class="count">
                        <countTo ref="counter3" class="count" :startVal='0' :endVal='3000' :duration='3000' :autoplay="false"  suffix="+" separator="" :useEasing="true">+</countTo>
                    </div>
                    <div class="name">
                        房源數量
                    </div>
                </li>
                <li>
                    <img src="@/assets/img/landingPage/home/typeA/lease.svg" alt="">
                    <div class="count">
                        <countTo ref="counter4" class="count" :startVal='0' :endVal='200' :duration='3000' :autoplay="false"  suffix="+" separator="" :useEasing="true">+</countTo>
                    </div>
                    <div class="name">
                        電子合約
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import countTo from 'vue-count-to';

export default {
    data () {
        return {
            // 是否已經count了
            hasCount: false,
        }
    },
    mounted () {
        // scroll監聽事件
        window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
        // 開始count
        startToCount() {
          this.$refs.counter1.start();
          this.$refs.counter2.start();
          this.$refs.counter3.start();
          this.$refs.counter4.start();
        },
        // 處理scroll event
        handleScroll () {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            var offsetTop = document.querySelector('.benefit').offsetTop

            if(scrollTop > offsetTop-100) {
                if(this.hasCount == false){
                    this.startToCount()
                    this.hasCount = true
                    // 取消scroll監聽事件
                    window.removeEventListener('scroll', this.handleScroll)
                }
            }
        },
    },
    components: {
        countTo
    }
}
</script>
<style lang="scss" scoped>
    .benefit{
        position: relative;
        display: flex;
        justify-content: center;
        .wrap{
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 911px;
            .dressing-ball{
                top: 191px;
                right: -40px;
            }
            .title{
                display: flex;
                align-items: center;
                font-size: 36px;
                font-weight: bold;
                margin-top: 86px;
                margin-bottom: 85px;
                img{
                    margin-right: 22px;
                }
            }
            >ul{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                margin-bottom: 170px;
                >li{
                    text-align: center;
                    width: 100%;
                    img{
                        width: 54px;
                    }
                    .count{
                        font-size: 40px;
                        font-weight: bold;
                        color: #0c6cff;
                        margin: 30px 0;
                    }
                    .name{
                        color: #636363;
                        font-size: 26px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1100px) {
        .benefit{
            padding: 0 29px;
            .wrap{
                width: unset;
                .dressing-ball{
                   display: none;
                }
                .title{
                    font-size: 18px;
                    margin-top: 28px;
                    margin-bottom: 59px;
                    img{
                        width: 30px;
                        margin-right: 11px;
                    }
                }
                >ul{
                    justify-content: space-between;
                    margin-bottom: 92px;
                    width: 400px;
                    flex-wrap: wrap;
                    >li{
                        width: 200px;
                        padding: 0px;
                        margin-right: 0;
                        margin-bottom: 39px;
                        img{
                            width: 33px;
                        }
                        .count{
                            font-size: 24px;
                            margin: 17px 0;
                        }
                        .name{
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 320px) {
        .benefit{
            .wrap{
                width: unset;
                >ul{
                    width: 280px;
                    >li{
                        width: 130px;
                        img{
                            width: 33px;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/officailPage/home/benefit.vue